export default __webpack_public_path__ + "static/media/SD-gallery-06.edf1bb50.png";